import { Box, Typography } from "@mui/material";
import AppLayout from "../advanced/layouts/AppLayout";
import ListeCotisationClientDetaches from "../components/web/ListeCotisationClientDetaches";

const ConsultationCotisationDetataches = () => {
  return (
    <AppLayout isShowSlider={false} contentContainerSx={{ py: 3 }}>
      <Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Consultation de cotisation pour les détachés
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Onpr offre une opportunité de visualiser vos cotisations en ligne
            d'une façon simple et rapide.
          </Typography>
        </Box>

        <Box>
          <ListeCotisationClientDetaches />
        </Box>
      </Box>
    </AppLayout>
  );
};

export default ConsultationCotisationDetataches;
